import http from "../http-common";
/* eslint-disable */
class TempatTidurService {
  tempatTidurList(page, itemPerPage, keyword, id) {
    return http.get(
      "/tempattidur/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&fasyankes_id=" +
        id,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    if (data.fasyankes_id)
      bodyFormData.append("fasyankes_id", data.fasyankes_id);
    if (data.kelas) bodyFormData.append("kelas", data.kelas);
    if (data.jumlah) bodyFormData.append("jumlah", data.jumlah);

    return http.post("/tempattidur", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    if (data.fasyankes_id)
      bodyFormData.append("fasyankes_id", data.fasyankes_id);
    if (data.kelas) bodyFormData.append("kelas", data.kelas);
    if (data.jumlah) bodyFormData.append("jumlah", data.jumlah);

    return http.put(`/tempattidur/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/tempattidur/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new TempatTidurService();
